var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import { useUniqueInlineId } from '@inline-svg-unique-id/react';
import * as React from "react";
function SvgNotifications(props) {
  var _id = useUniqueInlineId();
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#".concat(_id, ")")
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 28.001a3.944 3.944 0 100-7.888 3.944 3.944 0 000 7.888z",
    fill: "#FAB14B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.62 24.677H1.376a1.368 1.368 0 01-1.108-2.176l1.756-2.444a11.86 11.86 0 002.248-6.956V9.85a9.688 9.688 0 012.856-6.888A9.6 9.6 0 0111.38.485a7.79 7.79 0 011.304-.28 9.804 9.804 0 014.972.62 6.645 6.645 0 00-1.348 2.932 6.8 6.8 0 006.68 8.068c.252 0 .516-.02.76-.044v1.336c0 2.493.789 4.922 2.252 6.94l1.752 2.444a1.367 1.367 0 01-1.132 2.176z",
    fill: "#FAB14B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.36 24.676h-20A1.368 1.368 0 01.268 22.5l1.756-2.444A11.86 11.86 0 004.272 13.1V9.848A9.688 9.688 0 017.128 2.96 9.6 9.6 0 0111.38.484a9.704 9.704 0 014.932 3.272 6.798 6.798 0 002.152 6.336V13.1c0 2.498.788 4.933 2.252 6.956l1.756 2.444a1.377 1.377 0 01-1.112 2.176z",
    fill: "#FFD966"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.096 12.731c.9 0 1.628-1.538 1.628-3.436 0-1.897-.729-3.436-1.628-3.436-.9 0-1.628 1.539-1.628 3.436 0 1.898.729 3.436 1.628 3.436z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.972 10.056a5.028 5.028 0 100-10.056 5.028 5.028 0 000 10.056z",
    fill: "#F99"
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: _id
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h28v28H0z"
  })))));
}
export default SvgNotifications;